import React from 'react';

import d2d from '@assets/img/icons/d2d-new.svg';
import { Button } from '@components/Button';
import { FallbackRender } from '@sentry/react/types/errorboundary';
import { makeMuiStyles, useCommonStyles } from '@styles';
import { createStrings } from '@utils/local';
import clsx from 'clsx';

const strings = createStrings({
  ja: {
    error: 'エラー',
    errorTitle: '申し訳ございません。不明なエラーが発生しました。',
    errorPrompt: (
      <>
        問題が解決しない場合は、
        <a href="https://fcsl.force.com/d2d/s/" target="_blank" rel="noreferrer">
          サポート
        </a>
        にお問い合わせください。
      </>
    ),
    retry: '再試行',
    goBack: '戻る',
  },
});

const useStyles = makeMuiStyles((theme, common) => ({
  errorFallback: {
    ...common.flexColumnCenter,
    height: '100vh',
    backgroundColor: theme.palette.background.default,
    '& a': {
      ...common.textPrimary,
      textDecoration: 'underline',
    },
  },
  errorFallbackTitle: {
    ...common.normalText,
    fontWeight: 500,
    color: theme.palette.grey['800'],
    marginBottom: '2rem',
    textAlign: 'center',
  },
  errorMessage: {
    fontFamily: 'monospace',
    width: 400,
    backgroundColor: theme.palette.grey[200],
    padding: 16,
    marginBottom: 16,
  },
  logo: {
    height: 52 * 0.9,
    width: 182 * 0.9,
    marginBottom: '2rem',
  },
}));

export const ErrorFallback: FallbackRender = ({ error, resetError }) => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  return (
    <div role="alert" className={classes.errorFallback}>
      <a href="/">
        <img className={clsx(classes.logo, classes.baseButton)} src={d2d} alt="D2D Logo" />
      </a>

      <div className={classes.errorFallbackTitle}>
        {strings.errorTitle}
        <br />
        <br />
        {strings.errorPrompt}
      </div>

      <div className={classes.errorMessage}>{error.message}</div>

      <Button
        text={strings.retry}
        color="primary"
        onClick={() => (location.href = location.href)}
        style={{ width: 80 }}
        shape="round"
      />

      <div style={{ height: 16 }} />

      <Button
        text={strings.goBack}
        color="primary"
        onClick={() => {
          resetError();
          window.history.back();
        }}
        style={{ width: 80 }}
        shape="round"
      />
    </div>
  );
};
